<template>
    <div class="workspace-shortcut" aria-live="polite">
        <b-spinner small></b-spinner>
        <span>Открываем вашу вкладку…</span>
    </div>
</template>

<script>
import {
    getAvailableWorkspaces,
    getWorkspaceByKey
} from '@/utils/workspaceRegistry';

export default {
    name: 'WorkspaceShortcut',
    async mounted() {
        await this.loadContext();
        this.openWorkspace();
    },
    methods: {
        async loadContext() {
            const navigation = this.$store.state.navigationExperience || {};
            const loads = [
                this.$store.dispatch('objectCards/fetchAccessSettings').catch(() => {}),
                this.$store.dispatch('getEmployeeDirectorySettings').catch(() => {})
            ];
            if (navigation.loaded !== true) {
                loads.push(
                    this.$store.dispatch('navigation_loadSettings', {silent: true}).catch(() => {})
                );
            }
            if (!this.$can('read', 'fuelLimits')) {
                loads.push(this.$store.dispatch('getObjectsInProcess', {silent: true}).catch(() => {}));
            }
            await Promise.all(loads);
            await this.$nextTick();
        },
        effectiveWorkspace() {
            const available = getAvailableWorkspaces(this);
            const availableKeys = new Set(available.map(item => item.key));
            const navigation = this.$store.state.navigationExperience || {};
            const preferred = navigation.preferred_workspace_key;
            if (preferred && availableKeys.has(preferred)) {
                return getWorkspaceByKey(preferred);
            }
            if (preferred) {
                return null;
            }

            const defaults = Array.isArray(navigation.department_default_workspace_keys)
                ? navigation.department_default_workspace_keys
                : [];
            const availableDefaults = defaults.filter(key => availableKeys.has(key));
            if (availableDefaults.length === 1) {
                return getWorkspaceByKey(availableDefaults[0]);
            }
            if (availableDefaults.length > 1) {
                return null;
            }
            return available[0] || null;
        },
        openWorkspace() {
            const workspace = this.effectiveWorkspace();
            const navigation = this.$store.state.navigationExperience || {};
            const availableKeys = new Set(getAvailableWorkspaces(this).map(item => item.key));
            const defaults = Array.isArray(navigation.department_default_workspace_keys)
                ? navigation.department_default_workspace_keys
                : [];
            const needsChoice = Boolean(
                navigation.preferred_workspace_key ||
                defaults.filter(key => availableKeys.has(key)).length > 1
            );
            const fallback = needsChoice ? '/profile' : '/more';
            const target = workspace
                ? (workspace.to || workspace.path)
                : fallback;
            this.$router.replace(target).catch(() => {});
        }
    }
};
</script>

<style scoped>
.workspace-shortcut {
    display: flex;
    min-height: 180px;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #687588;
    font-size: 0.86rem;
}
</style>
